import { useEffect } from "react";

// restores the previous title on unmount so nested callers (page, then modal) stack correctly
const useDocumentTitle = (title) => {
  useEffect(() => {
    if (!title) return undefined;

    const previousTitle = document.title;
    document.title = title;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default useDocumentTitle;
